exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".black-zone {\n  z-index: 10000;\n}\n\n.show-all-item {\n  position: relative;\n}\n\n.show-all-text {\n  font-size: 24px;\n  position: absolute;\n  font-weight: bolder;\n  top: calc(50% - 20px);\n  left: calc(50% - 60px);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.show-all-img {\n  position: relative;\n}\n\n.show-all-text:hover {\n  color: #d50b01;\n}\n\n@media (max-width: 1199px) {\n  .show-all-text {\n    font-size: 18px;\n    top: calc(50% - 15px);\n    left: calc(50% - 45px);\n  }\n\n\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/vod/widgets/video-carousel/video-carousel.component.css
// module id = ../../../../../src/app/views/vod/widgets/video-carousel/video-carousel.component.css
// module chunks = main